import React from "react";
import KLSkeletonLoader from "../KLSkeletonLoader";

interface KLPleaseWaitProps {
  text: string;
  /**
   * @deprecated Use variant instead
   */
  variant?: "simple" | "list" | "form" | "card";
}

/**
 * @deprecated Use KLSkeletonLoader directly for better customization
 * This component is maintained for backward compatibility
 */
const KLPleaseWait: React.FC<KLPleaseWaitProps> = ({
  text,
  variant = "simple",
}) => {
  return <KLSkeletonLoader text={text} variant={variant} />;
};

export default KLPleaseWait;
